import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { SubGroupDetail } from './groupsManagement.types';
import { SubGroupData, SubGroupListParams } from './subGroups.types';

export const getSubGroupList = (client: AxiosInstance) => async (params?: SubGroupListParams) => {
  return (
    await client.get<PaginatedApiResponse<SubGroupData>>(API_ROUTES.GET_SUB_GROUP_LIST, {
      params: { ...params },
    })
  ).data;
};

export const getSubGroupDetail = (client: AxiosInstance) => async (subGroupId: string) => {
  return (
    await client.get<ApiResponse<SubGroupDetail>>(API_ROUTES.GET_SUB_GROUP_DETAIL, {
      params: { subGroupId: subGroupId || '' },
    })
  ).data;
};

export const SubGroupQueries = {
  all: () => ['subGroups'],

  list: (params?: SubGroupListParams) =>
    queryFactoryOptions<PaginatedApiResponse<SubGroupData>>({
      queryKey: [...SubGroupQueries.all(), 'list', params],
      queryFn: (client: AxiosInstance) => () => getSubGroupList(client)(params),
    }),
  detail: (subGroupId: string) =>
    queryFactoryOptions<ApiResponse<SubGroupDetail>>({
      queryKey: [...SubGroupQueries.all(), 'detail', subGroupId],
      queryFn: (client: AxiosInstance) => () => getSubGroupDetail(client)(subGroupId),
    }),
};
